import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { Footer, Navbar } from './components/layout';
import Home from './pages/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFound from './pages/NotFound';
import ApplicantList from './pages/applicants/ApplicantList';
import CreateApplicant from "./pages/applicants/Create";
import './styles.css';
import ReportViewerIFrame from './components/ReportViewerIFrame';
import { AuthProvider } from "./context/AuthContext";
import { AgentProvider } from "./context/AgentContext";
import { StatusProvider } from "./context/StatusContext";
import { CompanyProvider } from "./context/CompanyContext";
import Login from "./components/Login";
import Unauthorized from "./pages/Unauthorized";
import "devextreme/dist/css/dx.material.blue.light.compact.css";
import RoleBasedRoute from './components/RoleBasedRoute';
import DefaultSetting from './pages/DefaultSetting';
import EditApplicant from './pages/applicants/EditApplicant';
import CreateComplain from './pages/complains/CreateComplain';
import GenericReportViewer from './components/GenericReportViewer';
import DocumentViewer from './components/DocumentViewer';
import { UserSettingsProvider } from './context/UserSettingsContext';
import ChangeApplicantStatus from './pages/applicants/ChangeApplicantStatus';
import ChangeMedicalStatus from './pages/applicants/ChangeMedicalStatus';
import ChangeCocStatus from './pages/applicants/ChangeCocStatus';
import ChangeLmisDate from './pages/applicants/ChangeLmisDate';
import ChangeMusanedStatus from './pages/applicants/ChangeMusanedStatus';
import OverseasReport from './pages/filters/OverseasReport';
import GenericReportFilter from './components/GenericReportFilter';
import ComplainList from './pages/complains/ComplainList';
import EditComplain from './pages/complains/EditComplain';
import DeleteComplain from './pages/complains/DeleteComplain';
import CreateFlight from './pages/flights/CreateFlight';
import FlightList from './pages/flights/FlightList';
import EditFlight from './pages/flights/EditFlight';
import ApplicantSender from './pages/applicants/ApplicantSender';
import MoveApplicants from './pages/applicants/MoveApplicants';
import ChangePassword from './pages/accounts/ChangePassword';
import ManageAccounts from './pages/accounts/ManageAccounts';
import ResetPassword from './pages/accounts/ResetPassword';
import RegisterUser from './pages/accounts/RegisterUser';
import Register from './pages/accounts/Register';
import CompanyList from './pages/company/CompanyList';
import ApplicantListAG from './pages/applicants/ApplicantListAG';
import CVPreference from './pages/CVPreference';
import AgentApplicants from './pages/applicants/AgentApplicants';
import ChangeTasheerStatus from './pages/applicants/ChangeTasheerStatus';

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
      <AgentProvider>
        <StatusProvider>
        <UserSettingsProvider>
          <BrowserRouter>
            <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
              <Navbar />
              <div style={{ flex: 1 }}>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/accounts/changepassword" element={<ChangePassword />} />
                  <Route path="/accounts/manageaccounts" element={<ManageAccounts />} />
                  <Route path="/accounts/resetpassword" element={<ResetPassword />} />
                  <Route path="/accounts/registeruser" element={<RegisterUser />} />
                  <Route path="/accounts/register" element={<Register />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                  <Route path="/" element={<Home />} />
                  <Route path="/applicants/create" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "POWERADMIN"]}><CreateApplicant /></RoleBasedRoute>} />
                  <Route path="/applicants/edit/:id" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "POWERADMIN"]}><EditApplicant /></RoleBasedRoute>} />
                  <Route path="/applicants/applicantlist" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "POWERADMIN"]}><ApplicantList isInactive={false} key="active" /></RoleBasedRoute>} />
                  <Route path="/applicants/agent_applicants" element={<RoleBasedRoute allowedRoles={["AGENT", "FOREIGN AGENT", "FOREIGN COMPANY"]}><AgentApplicants /></RoleBasedRoute>} />
                  <Route path="/applicants/inactive-applicants" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "POWERADMIN"]}><ApplicantList isInactive={true} key="inactive"/></RoleBasedRoute>} />
                  <Route path="/applicants/sendApplicant/:id" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ApplicantSender /></RoleBasedRoute>} />
                  <Route path="/applicants/moveApplicants" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "POWERADMIN"]}><MoveApplicants /></RoleBasedRoute>} />
                  <Route path="/reports/applicantreport/:id" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><ReportViewerIFrame /></RoleBasedRoute>} />
                  <Route path="/reports/applicantSummary" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportViewer
                    reportUrl="/Reports/applicantSummary"
                    exportUrl="/Reports/applicant/export_summary"
                    reportName="ApplicantsSummaryRpt.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/commissionInquiry" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportViewer
                    reportUrl="/Reports/applicantSummary"
                    exportUrl="/Reports/applicant/export_summary"
                    reportName="InvoicePrintoutRpt.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/print_contract" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><GenericReportViewer
                    reportUrl="/Reports/print_contract"
                    exportUrl="/Reports/applicant/export_generic"
                    reportName="ContractKwtRpt.repx"
                  /></RoleBasedRoute>} />
                  
                  <Route path="/reports/print_cv" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><GenericReportViewer
                    reportUrl="/Reports/print_cv"
                    exportUrl="/Reports/applicant/export_generic"
                    reportName="CVReport.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/print_documents" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><DocumentViewer
                    reportUrl="/Reports/print_documents"
                    exportUrl="/Reports/applicant/export_documents"
                    reportName="CVReport.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/ticket-request" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportViewer
                    reportUrl="/Reports/applicantSummary"
                    exportUrl="/Reports/applicant/export_summary"
                    reportName="TicketcRequestRpt.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/print-benificary" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportViewer
                    reportUrl="/Reports/print_benificary"
                    exportUrl="/Reports/export_benificary"
                    reportName="InsuranceBnfRpt.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/print_complains" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportViewer
                    reportUrl="/Reports/print_complains"
                    exportUrl="/Reports/export_complains"
                    reportName="ComplainsReport.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/reports/print_passangers" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportViewer
                    reportUrl="/Reports/print_passangers"
                    exportUrl="/Reports/export_passangers"
                    reportName="PassengersRpt.repx"
                  /></RoleBasedRoute>} />
                  <Route path="/complains/create/:applicantId" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><CreateComplain /></RoleBasedRoute>} />
                  <Route path="/complains/edit/:id" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><EditComplain /></RoleBasedRoute>} />
                  <Route path="/complains/delete/:complainID" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><DeleteComplain /></RoleBasedRoute>} />
                  <Route path="/complains/complainlist" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ComplainList /></RoleBasedRoute>} />
                  <Route path="/flights/create" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><CreateFlight /></RoleBasedRoute>} />
                  <Route path="/flights/edit/:id" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><EditFlight /></RoleBasedRoute>} />
                  <Route path="/flights/flightlist" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><FlightList /></RoleBasedRoute>} />
                  <Route path="/applicants/changeStatus" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ChangeApplicantStatus /></RoleBasedRoute>} />
                  <Route path="/applicants/medicalStatus" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ChangeMedicalStatus /></RoleBasedRoute>} />
                  <Route path="/applicants/cocStatus" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ChangeCocStatus /></RoleBasedRoute>} />
                  <Route path="/applicants/musanedStatus" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ChangeMusanedStatus /></RoleBasedRoute>} />
                  <Route path="/applicants/changeLmisDate" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ChangeLmisDate /></RoleBasedRoute>} />
                  <Route path="/applicants/tasheerStatus" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ChangeTasheerStatus /></RoleBasedRoute>} />
                  <Route path="/companies/companylist" element={<RoleBasedRoute allowedRoles={["POWERADMIN"]}><CompanyList /></RoleBasedRoute>} />
                  <Route path="/applicants/applicantListAG" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN", "FOREIGN AGENT", "FOREIGN COMPANY"]}><ApplicantListAG /></RoleBasedRoute>} />
                  <Route path="/defaultsettings/create" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><DefaultSetting /></RoleBasedRoute>} />
                  <Route path="/cvpreferences/create" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><CVPreference /></RoleBasedRoute>} />
                  <Route path="/filters/citizens-condition" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><OverseasReport
                    _reportTitle="Citizens Condition"                    
                  /></RoleBasedRoute>} />
                  <Route path="/filters/ethiopianOverseas" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><OverseasReport
                    _reportTitle="Ethiopian Overseas Workers"                    
                  /></RoleBasedRoute>} />
                  <Route path="/filters/issuedLmisApplicants" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><OverseasReport
                    _reportTitle="Issued Applicant in LMIS"                    
                  /></RoleBasedRoute>} />
                  <Route path="/filters/applicantsDetail" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><OverseasReport
                    _reportTitle="Applicants Detail"                    
                  /></RoleBasedRoute>} />
                  <Route path="/reports/ethiopianOverseas" element={<RoleBasedRoute allowedRoles={["AGENCY", "ADMIN", "STAFF", "AGENT", "POWERADMIN"]}><GenericReportFilter
                    reportUrl="/Reports/ethiopianOverseas"
                    exportUrl="/Reports/exportOverseas"
                    reportName="EthOverseasWrkRpt.repx"                    
                  /></RoleBasedRoute>} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>              
              <Footer />
            </div>
          </BrowserRouter>
        </UserSettingsProvider>
        </StatusProvider>
      </AgentProvider>
      </CompanyProvider>
    </AuthProvider>
  );
}

serviceWorkerRegistration.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting;
    
    if (waitingServiceWorker) {
      // Automatically skip waiting and reload
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker registration with update handling
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // New update available
              console.log('New content is available; please refresh.');
              // You can show a notification to the user here
              if (window.confirm('A new version is available. Refresh now?')) {
                window.location.reload();
              }
            } else {
              // Content is cached for offline use
              console.log('Content is cached for offline use.');
            }
          }
        };
      };
    }).catch(error => {
      console.error('Error during service worker registration:', error);
    });

    // Check for updates every hour
    setInterval(() => {
      navigator.serviceWorker.ready.then(registration => {
        registration.update().catch(error => {
          console.log('Service worker update check failed:', error);
        });
      });
    }, 60 * 60 * 1000);
  });
}